<script>
import BotTemplate from "./views/template.vue";

export default {
    name: "App",
    render(h) {
        return h(BotTemplate, { props: {} });
    },
};
</script>



// WEBPACK FOOTER //
// App.vue